<template>
  <div class="row header">
    <!-- {{ 'listType: ' + listType }} -->
    <div class="col-lg-12">
      <template v-if="listType === 'pulsar'">
        <p class="text-center">
            <img src="../assets/logo.png" class="logo">
        </p>
        <h1>
          {{ $t("message.title") }}
      </h1>
      </template>
      <template v-else>
        <p class="text-center">
            <img src="../assets/logo.png" class="logo">
            <img src="../assets/logo_meanwell.jpg" class="logo" style="width: 175px;  padding: 10px;">
        </p>
        <h1>
          {{ $t("message.titleMW") }}
      </h1>
      </template>
    </div>
    <!-- <div class="col-lg-12">
      <div class="version">
        <span>v.0.8.1 / 2019-04-24</span>
      </div>
    </div> -->

    <template v-if="listType === 'pulsar'">
      <div class="col-lg-12" v-if="version">
        <div class="clause">
          <strong><span>{{ $t("message.clause1")}}</span></strong><br>
          <span>{{ $t("message.clause2")}}</span>
          <strong><span>{{ $t("message.clause3", {version: version.pulsarNumer, data_start: version.pulsarData}) }}</span></strong>
          <span>{{ $t("message.clause4")}}</span><br>
          <!-- <span>{{ $t("message.clause5", {data:dzis()}) }}</span> -->
        </div>
      </div>
    </template>
    <template v-else>
      <div class="col-lg-12" v-if="version">
        <div class="clause">
          <strong><span>{{ $t("message.clause1")}}</span></strong><br>
          <span>{{ $t("message.clause2")}}</span>
          <strong><span>{{ $t("message.clause3", {version: version.mwNumer, data_start: version.mwData}) }}</span></strong>
          <span>{{ $t("message.clause4")}}</span><br>
          <!-- <span>{{ $t("message.clause5", {data:dzis()}) }}</span> -->
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "Header",
  // props: ['listType'],
  data() {
    return {
      msg: "Header",
      info: '',
    };
  },
  computed: {
     ...mapGetters('version', ['version']),
     ...mapGetters('pricelist', ['listType'])
  },
  methods:{
    leadingZero(i) {
      return (i < 10)? '0'+i : i;
    },
    dzis(){
      var currentDate = new Date();
      return this.leadingZero(currentDate.getDate()) + "." + this.leadingZero(currentDate.getMonth()+1) + "." + currentDate.getFullYear();
    }
  },
  async mounted () {
    console.log('-- header mounted --')
    // this.$store.dispatch('version/load_version',[])
    await this.$store.dispatch('version/load_version', [])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

.header {
  margin-bottom: 20px;
  h1 {
    font-size: 1.2em;
    text-align: center;
    font-weight: 700;
    @media (min-width: 576px) {
      font-size: 1.3em;
    }
  }
  .version {
    font-size: 0.6em;
    text-align: center;
    @media (min-width: 576px) {
      font-size: 0.8em;
    }
  }
  .clause {
    font-size: 0.6em;
    text-align: center;
    @media (min-width: 576px) {
      font-size: 0.7em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue